<div fxLayout="row" fxLayoutWrap>
  <div fxLayout="column" class="container" fxFill>
    <div>
      <mat-form-field>
        <input matInput #filter placeholder="{{'main_number_table.filter_placeholder' | translate}}" [(ngModel)]="filterStr">
        <button mat-icon-button matSuffix (click)="clearFilter()">
          <mat-icon *ngIf="filterStr">clear</mat-icon>
          <mat-icon *ngIf="!filterStr">search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <table mat-table [dataSource]="mainNumberDataSource" matSort #sortForDataSource="matSort">

      <!-- Column Definition: name -->
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'main_number_table.col_time' | translate}} </th>
        <td mat-cell *matCellDef="let row" i18n> {{row.callStart | timeAndDateFormatter}} </td>
      </ng-container>

      <!-- Column Definition: status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'main_number_table.col_status' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          {{row | callCauseString}}
          <span *ngIf="row.handledBy"> ({{'call_log.handled' | translate }}) </span>
        </td>
      </ng-container>

      <!-- Column Definition: caller -->
      <ng-container matColumnDef="caller">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'main_number_table.col_caller' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div *ngIf="row.caller" class="truncate-text" matTooltip="{{displayCallerName(row)}}" matTooltipPosition="right"
                 matTooltipClass="larger-tooltip">{{row.caller}} </div>
            <span *ngIf="row.fullNumber" fxFlex="noshrink">&nbsp;({{row.fullNumber | phoneNumberFormatter}})&nbsp;</span>
          </div>
        </td>
      </ng-container>

      <!-- Column Definition: duration -->
      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'main_number_table.col_duration' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.duration | durationFormatter}}</td>
      </ng-container>

      <!-- Column Definition: accessNumber -->
      <ng-container matColumnDef="accessNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'main_number_table.col_access_number' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.accessNumber}} </td>
      </ng-container>

      <!-- Column Definition: answeredBy -->
      <ng-container matColumnDef="answeredBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'main_number_table.col_answered_by' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.answeredBy}} </td>
      </ng-container>

      <!-- Column Definition: handledBy -->
      <ng-container matColumnDef="handledBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'main_number_table.col_handled_by' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.handledByName}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="mainNumberDataSourceColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: mainNumberDataSourceColumns;"
               [gtCdkDetailRow]="row" [gtCdkDetailRowTpl]="tpl">
      </tr>
    </table>

    <mat-paginator #paginatorForDataSource [length]="mainNumberDataSource.data.length" [pageSizeOptions]="[10, 25, 100]">
    </mat-paginator>
  </div>
</div>


<ng-template #tpl let-element>
  <div class="expanded-section" fxLayout="column">
    <gt-redirect-history [redirectEntries]="element.redirectEntries"></gt-redirect-history>
    <div fxLayout="row" fxLayoutAlign="start center"  fxLayoutGap="16px" fxFlexAlign="start" style="margin-bottom: 16px; margin-top: 8px;">
      <button mat-raised-button (click)="click2call(element)" color="primary" class="btn-click2call" gtDisableWhenNotloggedin>{{'main_number_table.click2call' | translate}}</button>
      <button mat-button (click)="showContact(element)" color="primary" class="btn-show-contact">{{'main_number_table.caller_info' | translate}}</button>
      <button mat-button (click)="sendSMS(element)" color="primary" class="btn-send-sms">{{'main_number_table.send_sms' | translate}}</button>
      <button mat-button (click)="sendSMS(element, true)" color="primary" class="btn-send-contact">{{'main_number_table.send_contact_details' | translate}}</button>
    </div>
  </div>
</ng-template>
